import { Link } from "react-router-dom";
import { Clock } from "lucide-react";

export function BlogCard({ post, featured = false }) {
  return (
    <Link
      to={`/blog/${post.slug}`}
      data-testid={`blog-card-${post.slug}`}
      className={`group flex flex-col overflow-hidden rounded-2xl border border-rw-border bg-rw-card transition-all duration-300 hover:border-rw-border2 hover:bg-rw-cardh hover:-translate-y-1 ${featured ? "lg:flex-row" : ""}`}
    >
      <div className={`relative overflow-hidden ${featured ? "lg:w-1/2 aspect-[16/9] lg:aspect-auto" : "aspect-[16/9]"}`}>
        <img
          src={post.cover}
          alt={post.cover_alt || post.title}
          loading="lazy"
          width="940" height="529"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-4 top-4 rounded-full bg-rw-bg/85 backdrop-blur px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-rw-green border border-rw-border">
          {post.category}
        </span>
      </div>
      <div className={`flex flex-1 flex-col p-6 ${featured ? "lg:justify-center lg:p-10" : ""}`}>
        <h3 className={`font-jakarta font-bold text-rw-text leading-snug group-hover:text-rw-green transition-colors ${featured ? "text-xl sm:text-2xl" : "text-base sm:text-lg"}`}>
          {post.title}
        </h3>
        <p className="mt-3 text-sm text-rw-muted leading-relaxed line-clamp-2">{post.excerpt}</p>
        <div className="mt-4 flex items-center gap-3 text-xs text-rw-dim">
          <span>{post.author}</span>
          <span aria-hidden="true">·</span>
          <span>{new Date(post.published_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}</span>
          <span aria-hidden="true">·</span>
          <span className="inline-flex items-center gap-1"><Clock size={12} /> {post.reading_time} min</span>
        </div>
      </div>
    </Link>
  );
}
